module.exports = __webpack_public_path__ + "files/64e120cc7671c2c1517f10e377e430f6.svg";